import polyline from '@mapbox/polyline'

export const utils = {
  polyline,
}
